const APP_UTILS_MODULE_PROVIDERS = [];

export {APP_UTILS_MODULE_PROVIDERS};
